import { Component, Inject, Input, Optional } from '@angular/core';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { StateDialogContext, TT_STATE_DIALOG } from '@app/modal/state-modal/state-modal.component';

@GridModalComponent('stockbatchlogg')
@Component({
    selector: 'tt-stock-batch-logg',
    templateUrl: './stock-batch-logg.component.html',
    styleUrls: ['./stock-batch-logg.component.css'],
})
export class StockBatchLoggComponent {
    @Input()
    public params?: GetStockBatchLoggParams;

    public grid?: GridOptions;

    constructor(@Optional() @Inject(TT_STATE_DIALOG) stateContext: StateDialogContext) {
        this.initFromDialog(stateContext);
    }

    private createGrid() {
        this.grid = new Grid().setRememberId('w_stockbatchlogg.grid').setLoadDataFunction({ method: 3963, parameters: () => this.params });
    }

    private async init() {
        this.createGrid();
    }

    private async initFromDialog(state: StateDialogContext) {
        if (!!state) {
            state.setSize({ height: '80vh', width: '95vw' });
            state.setHeading('p2_m_stockbatchlogg', true);
            this.params = state.params as unknown as GetStockBatchLoggParams;
            await this.init();
        }
    }
}
export interface GetStockBatchLoggParams {
    argtype: string;
    argvalue: string;
}
